import { Switch, Route, Redirect } from "react-router-dom";
import { LeaderboardRanking } from "@ugg/shared/components/Leaderboards/LeaderboardRanking";
import { AppRoutes } from "@ugg/shared/routes/app-routes";

export function LeaderboardRoutes() {
  return (
    <Switch>
      <Route path={AppRoutes.LEADERBOARD_RANKING} component={LeaderboardRanking} />
      <Redirect to={AppRoutes.LEADERBOARD_RANKING} />
    </Switch>
  );
}
